export default __webpack_public_path__ + "static/media/share.08d88090.svg";